import React from 'react';
import { Button } from '../components/ui/Button';
import { ArrowRightIcon, BuildingIcon, ShoppingBagIcon, BotIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
export function VenturesPage() {
  return <div className="w-full" data-id="element-756">
      {/* Hero Section */}
      <section className="bg-black text-white py-20 relative" data-id="element-757">
        <div className="absolute inset-0 z-0 overflow-hidden" data-id="element-758">
          <img src="https://images.unsplash.com/photo-1573164713988-8665fc963095?ixlib=rb-1.2.1&auto=format&fit=crop&w=1950&q=80" alt="Ventures Hero" className="w-full h-full object-cover opacity-50" data-id="element-759" />
        </div>
        <div className="container mx-auto px-4 relative z-10" data-id="element-760">
          <div className="max-w-3xl" data-id="element-761">
            <h1 className="text-4xl md:text-5xl font-bold mb-6" data-id="element-762">
              Our Ventures
            </h1>
            <p className="text-xl text-gray-300" data-id="element-763">
              Discover our portfolio of innovative businesses spanning
              hospitality, commerce, and AI technology.
            </p>
          </div>
        </div>
      </section>
      {/* Ventures Overview */}
      <section className="py-16 md:py-24 bg-white" data-id="element-764">
        <div className="container mx-auto px-4" data-id="element-765">
          <div className="max-w-3xl mx-auto text-center mb-16" data-id="element-766">
            <h2 className="text-3xl md:text-4xl font-bold text-black mb-6" data-id="element-767">
              Our Portfolio
            </h2>
            <p className="text-lg text-gray-600" data-id="element-768">
              At Rawfounders, we build and invest in businesses that have the
              potential to transform industries and create significant value.
              Our ventures span multiple sectors, with a focus on hospitality,
              commerce, and technology.
            </p>
          </div>
        </div>
      </section>
      {/* Rawfound Properties */}
      <section className="py-16 md:py-24 bg-gray-50" data-id="element-769">
        <div className="container mx-auto px-4" data-id="element-770">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-16 items-center max-w-6xl mx-auto" data-id="element-771">
            <div data-id="element-772">
              <div className="mb-6" data-id="element-773">
                <BuildingIcon className="h-16 w-16 text-black" data-id="element-774" />
              </div>
              <h2 className="text-3xl font-bold text-black mb-6" data-id="element-775">
                Rawfound Properties
              </h2>
              <p className="text-lg text-gray-600 mb-6" data-id="element-776">
                Specialized hospitality brokerage, consulting, and investor
                advisory services for the global hotel industry. We help hotel
                owners, investors, and operators navigate the complex
                hospitality landscape.
              </p>
              <h3 className="text-xl font-semibold text-black mb-3" data-id="element-777">
                Services Include:
              </h3>
              <ul className="list-disc pl-5 text-gray-600 mb-8 space-y-2" data-id="element-778">
                <li data-id="element-779">Hotel Brokerage & Transactions</li>
                <li data-id="element-780">Investment Advisory</li>
                <li data-id="element-781">Asset Management</li>
                <li data-id="element-782">Hospitality Consulting</li>
                <li data-id="element-783">Market Analysis & Feasibility Studies</li>
              </ul>
              <Button href="/rawfound-properties" className="mr-4" data-id="element-784">
                Learn More
              </Button>
              <Button href="/contact" variant="outline" data-id="element-785">
                Contact Team
              </Button>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-sm" data-id="element-786">
              <img src="https://images.unsplash.com/photo-1566073771259-6a8506099945?ixlib=rb-1.2.1&auto=format&fit=crop&w=1350&q=80" alt="Luxury Hotel" className="w-full h-auto rounded-lg" data-id="element-787" />
            </div>
          </div>
        </div>
      </section>
      {/* Shoplinky */}
      <section className="py-16 md:py-24 bg-white" data-id="element-788">
        <div className="container mx-auto px-4" data-id="element-789">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-16 items-center max-w-6xl mx-auto" data-id="element-790">
            <div className="order-2 md:order-1 bg-gray-50 p-6 rounded-lg shadow-sm" data-id="element-791">
              <img src="https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?ixlib=rb-1.2.1&auto=format&fit=crop&w=1350&q=80" alt="E-commerce Platform" className="w-full h-auto rounded-lg" data-id="element-792" />
            </div>
            <div className="order-1 md:order-2" data-id="element-793">
              <div className="mb-6" data-id="element-794">
                <ShoppingBagIcon className="h-16 w-16 text-black" data-id="element-795" />
              </div>
              <h2 className="text-3xl font-bold text-black mb-6" data-id="element-796">Shoplinky</h2>
              <p className="text-lg text-gray-600 mb-6" data-id="element-797">
                An AI-powered influencer commerce platform enabling creators to
                monetize their content and build sustainable businesses.
                Shoplinky provides end-to-end solutions for creator commerce.
              </p>
              <h3 className="text-xl font-semibold text-black mb-3" data-id="element-798">
                Features Include:
              </h3>
              <ul className="list-disc pl-5 text-gray-600 mb-8 space-y-2" data-id="element-799">
                <li data-id="element-800">AI-powered Product Recommendations</li>
                <li data-id="element-801">Seamless Social Media Integration</li>
                <li data-id="element-802">Automated Affiliate Marketing</li>
                <li data-id="element-803">Creator Analytics Dashboard</li>
                <li data-id="element-804">Multi-platform Content Monetization</li>
              </ul>
              <Button href="/shoplinky" className="mr-4" data-id="element-805">
                Learn More
              </Button>
              <Button href="/contact" variant="outline" data-id="element-806">
                Contact Team
              </Button>
            </div>
          </div>
        </div>
      </section>
      {/* Agentter.ai */}
      <section className="py-16 md:py-24 bg-gray-50" data-id="element-807">
        <div className="container mx-auto px-4" data-id="element-808">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-16 items-center max-w-6xl mx-auto" data-id="element-809">
            <div data-id="element-810">
              <div className="mb-6" data-id="element-811">
                <BotIcon className="h-16 w-16 text-black" data-id="element-812" />
              </div>
              <h2 className="text-3xl font-bold text-black mb-6" data-id="element-813">
                Agentter.ai
              </h2>
              <p className="text-lg text-gray-600 mb-6" data-id="element-814">
                Advanced AI-powered agents for commerce and operations,
                streamlining business processes and enhancing customer
                experiences. Our AI agents help businesses automate routine
                tasks and provide personalized customer interactions.
              </p>
              <h3 className="text-xl font-semibold text-black mb-3" data-id="element-815">
                Solutions Include:
              </h3>
              <ul className="list-disc pl-5 text-gray-600 mb-8 space-y-2" data-id="element-816">
                <li data-id="element-817">Customer Service AI Agents</li>
                <li data-id="element-818">Sales & Marketing Automation</li>
                <li data-id="element-819">Operational Workflow Optimization</li>
                <li data-id="element-820">Personalized Shopping Assistants</li>
                <li data-id="element-821">Data Analysis & Business Intelligence</li>
              </ul>
              <Button href="/agentter" className="mr-4" data-id="element-822">
                Learn More
              </Button>
              <Button href="/contact" variant="outline" data-id="element-823">
                Contact Team
              </Button>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-sm" data-id="element-824">
              <img src="https://images.unsplash.com/photo-1531746790731-6c087fecd65a?ixlib=rb-1.2.1&auto=format&fit=crop&w=1350&q=80" alt="AI Technology" className="w-full h-auto rounded-lg" data-id="element-825" />
            </div>
          </div>
        </div>
      </section>
      {/* CTA Section */}
      <section className="py-16 md:py-24 bg-black text-white" data-id="element-826">
        <div className="container mx-auto px-4 bg-pattern" data-id="element-827">
          <div className="max-w-4xl mx-auto text-center" data-id="element-828">
            <h2 className="text-3xl md:text-4xl font-bold mb-6" data-id="element-829">
              Interested in Our Ventures?
            </h2>
            <p className="text-xl text-gray-300 mb-10 max-w-2xl mx-auto" data-id="element-830">
              Whether you're looking to partner with us, explore investment
              opportunities, or learn more about our portfolio companies, we'd
              love to hear from you.
            </p>
            <Button href="/contact" size="lg" data-id="element-831">
              Get in Touch
            </Button>
          </div>
        </div>
      </section>
    </div>;
}